module.exports = __webpack_public_path__ + "img/z12.6629f844.png";